module.exports = __webpack_public_path__ + "img/icon_nav4_active.14586cbb.89221e27.svg";